import React, { Suspense, lazy } from "react";
import "./App.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Util/Loader/Loader";

const Login = lazy(() =>
  import(/* webpackChunkName: "Login" */ "./Login/Login")
);

const AdminDashboard = lazy(() =>
  import(
    /* webpackChunkName: "AdminDashboard" */ "./AdminDashboard/AdminDashboard"
  )
);

const Clients = lazy(() =>
  import(/* webpackChunkName: "Clients" */ "./Clients/Clients")
);

const ClientProject = lazy(() =>
  import(
    /* webpackChunkName: "ClientProject" */ "./ClientProject/ClientProject"
  )
);

const Steps = lazy(() =>
  import(/* webpackChunkName: "Steps" */ "./Steps/Steps")
);

const OrderBundle = lazy(() =>
  import(/* webpackChunkName: "OrderBundle" */ "./OrderBundle/OrderBundle")
);

const OrderGroupDetails = lazy(() =>
  import(
    /* webpackChunkName: "OrderGroupDetails" */ "./OrderGroupDetails/OrderGroupDetails"
  )
);

const OrderInfo = lazy(() =>
  import(/* webpackChunkName: "OrderInfo" */ "./OrderInfo/OrderInfo")
);

const theme = createTheme({
  palette: {
    primary: {
      main: "#0064E0",
    },
    secondary: {
      main: "#000",
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/admin-dashboard" component={AdminDashboard} />
              <Route path="/clients" component={Clients} />
              <Route path="/client/:id" component={ClientProject} />
              <Route path="/steps" component={Steps} />
              <Route path="/order-bundles" component={OrderBundle} />
              <Route path="/order-bundle/:id" component={OrderGroupDetails} />
              <Route path="/order/:orderId" component={OrderInfo} />
              <Route component={Login} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
